import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch, ApiError } from '@/lib/api';
import { useToast } from '@/lib/toast';
import type { KommunikationUpdateRequest } from '@/types/detail';

export function usePatchKommunikation(bestellnr: string) {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: (body: KommunikationUpdateRequest) =>
      apiFetch<{ id: number }>('/kommunikation/update.php', {
        method: 'POST',
        body: JSON.stringify(body)
      }),
    onSuccess: () => {
      toast('success', 'Kommunikation aktualisiert.');
      qc.invalidateQueries({ queryKey: ['bestellung', bestellnr] });
    },
    onError: (err) => {
      const code = err instanceof ApiError ? err.code : 'unbekannt';
      if (code === 'forbidden_edit_window_expired') {
        toast('error', 'Editier-Fenster (60 Min) ist abgelaufen.');
      } else if (code === 'forbidden_other_user') {
        toast('error', 'Nur der Verfasser kann den Eintrag ändern.');
      } else {
        toast('error', `Aktualisieren fehlgeschlagen: ${code}`);
      }
    }
  });
}
